import { useState } from "react";
import IntlMessages from "../../../../util/IntlMessages";
import { parseMailContent } from "../../../../util/Scripts";
import { Button, Modal } from "../../../BP2Components";
import "./MailContentModal.less";

const MailContentModal = ({ content }) => {
   const [isVisible, setIsVisible] = useState(false);
   const toggleModal = () => setIsVisible(!isVisible);
   const parsedMail = parseMailContent(content);

   return (
      <>
         <Button style={{ width: "100%" }} onClick={toggleModal}>
            <IntlMessages id="mail.viewContent" />
         </Button>
         {isVisible && (
            <Modal
               isOpen={isVisible}
               onCancel={toggleModal}
               wrapClassName="mail-content-modal"
               width={800}
               height={600}
            >
               <div
                  className="mail-content-modal__content"
                  dangerouslySetInnerHTML={{ __html: parsedMail.content }}
               />
            </Modal>
         )}
      </>
   );
};

export default MailContentModal;
